export default __webpack_public_path__ + "static/media/NSRM.91b807fe.png";